import { Component, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { BansStorageService } from '../../services/bans-storage.service';

@Component({
  selector: 'app-bans-dropdown',
  templateUrl: './bans-dropdown.component.html',
  styleUrls: ['./bans-dropdown.component.css']
})

export class BansDropdownComponent {

  @Input() banCAs: any;
  @Input() ban: any

  @Output() selectedBAN = new EventEmitter<any>();

  @ViewChild('searchInputRef') searchInputElement!: ElementRef;

  searchInput: string = '';
  dropdownVisible: boolean = false;
  menuBtnClick: boolean = false;
  isBansPresent: Boolean = true;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler() {
    this.dropdownVisible = false;
  }

  constructor(
    private renderer: Renderer2,
    private bansService: BansStorageService
  ) {
    // Automatically close the dropdown on outside click
    this.renderer.listen('window', 'click', (e: Event) => {
      if (!this.menuBtnClick) {
        this.dropdownVisible = false;
      }
      this.menuBtnClick = false;
    });
  }

  // Getter to filter BANs based on the search input.
  get getBANs() {
    let searchArray = new Map<string, Array<string>>();
    this.bansService.banFlag.subscribe(
      (isPresent: boolean) => {
        if (!isPresent) {
          this.isBansPresent = false;
        }
      }
    );
    if (this.searchInput) {
      for (const ban of this.banCAs.entries()) {
        if (ban[0].toLowerCase().includes(this.searchInput.toLowerCase())) {
          searchArray.set(ban[0], ban[1])
        }
      }
      return searchArray;
    }
    else {
      return this.banCAs;
    }
  }

  // Handles the selection of a BAN.
  selectBan(selectedBan: any): void {
    localStorage.setItem("Selected_BAN_Dropdown_Value", selectedBan);
    let banCAs = this.banCAs.get(selectedBan)
    localStorage.setItem("Selected_BAN_CAs_Dropdown", banCAs);
    this.selectedBAN.emit(selectedBan);
    this.dropdownVisible = false;
  }

  // Toggles the visibility of the dropdown menu.
  toggleDropdown() {
    if (!this.isBansPresent) {
      return
    }
    this.dropdownVisible = !this.dropdownVisible
    if (this.dropdownVisible) {
      this.menuBtnClick = true;
    }
  }

  // Prevents closing the dropdown when interacting with child elements.
  handleChildClick(event: Event): void {
    const target = event.target as HTMLElement;
    const validIds = ['ban-dropdown-search', 'ban-dropdown-loader'];
    const validClasses = ['dropdown-menu show', 'api-loader', 'no-results'];
    if (validIds.includes(target.id) || validClasses.includes(target.className)) {
      this.menuBtnClick = true;
    }
  }

  // clear search input value
  clearSearchInput(): void {
    this.menuBtnClick = true;
    this.searchInput = '';
    this.searchInputElement.nativeElement.focus();
  }
}
